import React from "react";
import { Box, IconButton, Button } from "@mui/material";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import ChatList from "./ChatList";

interface SidebarProps {
  sidebarOpen: boolean;
  toggleSidebar: () => void;
  chats: any[];
  activeChat: string | null;
  // This prop's signature is important for the new responsive logic
  setActiveChat: (chatId: string | null) => void;
  onNewChat: () => void;
  onEditChat: (chatId: string) => void;
  onFeedbackChat: (chatId: string) => void;
  onDeleteChat: (chatId: string) => void;
  isGenerating: boolean;
  isLoading: boolean;
  onLoadMore: () => Promise<void>;
  hasMore: boolean;
}

const Sidebar: React.FC<SidebarProps> = ({
  sidebarOpen,
  toggleSidebar,
  chats,
  activeChat,
  setActiveChat,
  onNewChat,
  onEditChat,
  onFeedbackChat,
  onDeleteChat,
  isGenerating,
  isLoading,
  onLoadMore,
  hasMore,
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      height="100%"
      sx={{ overflow: "hidden" }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        p={1.5}
      >
        <IconButton onClick={toggleSidebar} aria-label="Hide sidebar">
          <ChevronLeftIcon />
        </IconButton>
        <Button
            variant="outlined"
            size="small"
            startIcon={<AddOutlinedIcon />}
            color="primary"
            onClick={onNewChat}
            disabled={isGenerating}
            sx={{ textTransform: 'none', borderRadius: '12px', height: 38, }}
          >
            เริ่มหัวข้อใหม่
        </Button>
      </Box>
      <Box
          sx={{
            flexGrow: 1,
            minHeight: 0,
            position: "relative",
            overflow: "hidden",
          }}
        >
          <ChatList
            activeChat={activeChat}
            setActiveChat={setActiveChat}
            onEditChat={onEditChat}
            onFeedbackChat={onFeedbackChat}
            onDeleteChat={onDeleteChat}
            chats={chats}
            isGenerating={isGenerating}
            isLoading={isLoading}
            onLoadMore={onLoadMore}
            hasMore={hasMore}
          />
        </Box>
    </Box>
  );
};

export default Sidebar;